import { Device, ISvgStartPosition } from 'types';
import { Winners } from 'constants/common';

export type { PredictionWinnerType } from './PredictionsSection/components/PredictionShortcut';

export interface IRoadItem {
  outcome: Winners;
  isTie?: boolean;
  consecutiveTiesQty?: number;
  isPrediction?: boolean;
  isPlayerPair?: boolean;
  isBankerPair?: boolean;
}

export type RoadItemType = IRoadItem | undefined;

export type IRoadItems = RoadItemType[];

export interface IScoreboardRoad {
  roadData: IRoadItems;
  position?: ISvgStartPosition;
}

export enum ScoreboardColors {
  Black = 'Black',
  Blue = 'Blue',
  Green = 'Green',
  LightDark = 'LightDark',
  LightGold = 'LightGold',
  OffWhite = 'OffWhite',
  SignalRed = 'SignalRed',
}

export type IScoreboardColors = Record<ScoreboardColors, string>;

export const scoreboardColors: IScoreboardColors = {
  [ScoreboardColors.Black]: '#121011',
  [ScoreboardColors.Blue]: '#52B1DF',
  [ScoreboardColors.Green]: '#43A91D',
  [ScoreboardColors.LightDark]: '#343434',
  [ScoreboardColors.LightGold]: '#E7D5B9',
  [ScoreboardColors.OffWhite]: '#FFF7EB',
  [ScoreboardColors.SignalRed]: '#EA184A',
};

export interface IDeviceBaseScoreboardProps {
  deviceType?: Device;
}
